import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./lib/cart";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { CartDrawer } from "./components/site/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import { PaymentCancel, PaymentSuccess } from "./pages/Payment";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

let lenis;

const useLenis = () => {
  useEffect(() => {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.querySelector(hash) : null;
      if (el) lenis ? lenis.scrollTo(el, { offset: -64 }) : el.scrollIntoView();
      else lenis ? lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
    }, 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

const SiteLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
    <CartDrawer />
  </>
);

function App() {
  useLenis();
  return (
    <div className="grain min-h-screen bg-[#090D12] text-slate-50">
      <CartProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </CartProvider>
    </div>
  );
}

export default App;
